export default __webpack_public_path__ + "static/media/3318.24dc58df.png";